module.exports = __webpack_public_path__ + "img/DE02712.766dbd8c.png";